import { defaultResetDurationInSeconds } from '../../../constants/limitations'

export const defaultDuration = defaultResetDurationInSeconds
export const defaultFramesCount = 1
export const frameDurationMultiplier = 0.15
